import Modal from "components/foundation/Modal/Modal";
import React from "react";
import { useForm } from "react-hook-form";
import styled from "styled-components";
import { UserProfileInput } from "../UserProfileInput/UserProfileInput";
import useUserDeleteMutation from "features/user/hooks/mutations/useUserDeleteMutation";

interface FormData {
  password: string;
}

interface WithDrawModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

const WithDrawModal = ({ isOpen, setIsOpen }: WithDrawModalProps) => {
  const { register, handleSubmit, reset } = useForm<FormData>();
  const { mutate } = useUserDeleteMutation();

  const handleWithDraw = (data: FormData) => {
    mutate(
      {
        password: data.password,
      },
      {
        onSuccess: () => {
          setIsOpen(false);
          reset();
        },
      },
    );
  };
  return (
    <Modal.Root open={isOpen} onOpenChange={setIsOpen}>
      <ModalBody
        title="정말 탈퇴하시겠습니까?"
        onCancel={() => {
          setIsOpen(false);
        }}
        onConfirm={() => {
          handleSubmit(handleWithDraw)();
        }}
        confirmValue="탈퇴"
      >
        <Message>
          아래 입력창에 비밀번호를 입력한 뒤, <strong>탈퇴</strong> 버튼을 클릭
          하시면 해당 계정은 삭제됩니다.
        </Message>
        <ErrorMessage>* 탈퇴 이후 해당 계정 접근 불가</ErrorMessage>

        <UserProfileInput
          label="비밀번호 재입력"
          placeholder="비밀번호를 입력해 주세요"
          type="password"
          {...register("password")}
        />
      </ModalBody>
    </Modal.Root>
  );
};

export default WithDrawModal;

const ModalBody = styled(Modal.Body)`
  width: 38rem;

  ${({ theme }) => theme.media.small} {
    width: calc(100% - 6rem);
  }
`;

const Message = styled.div`
  ${({ theme }) => theme.typography.body1.regular};
  margin-bottom: 1.2rem;

  > strong {
    ${({ theme }) => theme.typography.body1.semibold};
    color: ${({ theme }) => theme.color.text.highEmphasis};
  }

  ${({ theme }) => theme.media.small} {
    margin-bottom: 0.8rem;
    ${({ theme }) => theme.typography.body3.regular};

    > strong {
      ${({ theme }) => theme.typography.body3.semibold};
    }
  }
`;

const ErrorMessage = styled.p`
  ${({ theme }) => theme.typography.body3.regular};
  color: ${({ theme }) => theme.color.text.danger};

  margin-bottom: 3rem;

  ${({ theme }) => theme.media.small} {
    ${({ theme }) => theme.typography.caption1.regular};
  }
`;
